import * as React from 'react';
import { SVGProps } from 'react';

const IconMLSPSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1H4v1h.649l-.855 4H2v1h8V6H8.206l-.855-4H8V1ZM6.543 3H5.457l-.64 3h2.367l-.641-3Z"
    />
    <path d="M3 9.48a5.7 5.7 0 0 1-.325-.2c-.309-.192-.55-.32-.884-.32-.202 0-.474.084-.791.243V8.114c.26-.093.529-.155.791-.155.636 0 1.085.269 1.413.473.356.222.517.322.723.322.185 0 .322-.086.58-.29l.043-.034c.225-.18.59-.47 1.097-.47.494 0 .857.279 1.086.454l.056.043c.255.193.424.297.67.297.231 0 .356-.089.579-.278l.035-.03c.22-.19.567-.487 1.122-.487.514 0 .962.26 1.277.442l.04.022c.197.114.352.2.488.255V9.72c-.376-.076-.702-.265-.948-.407l-.04-.023c-.372-.215-.597-.33-.817-.33A.413.413 0 0 0 9 9.002V11H8V9.665a1.63 1.63 0 0 1-.54.089c-.602 0-1.002-.294-1.273-.498-.304-.23-.404-.297-.54-.297-.133 0-.237.067-.52.29l-.01.008c-.234.185-.595.47-1.117.495V11H3V9.48Z" />
  </svg>
);
export default IconMLSPSizeXs;
